<button type="button"
        #button
        (keyup)="onKeyUp($event)"
        [ngClass]="getClass()"
        [ngStyle]="getStyle()"
        [style.width]="!fullWidth? '-moz-fit-content':''"
    [attr.title]="title || label || null"
        [disabled]="disabled"
        (click)="emitClick($event)">
    <ng-container *ngIf="!isFormSaveButton()">
        <i *ngIf="icon && icon !== ''"
           [ngClass]="getIconClass()">
            {{icon}}
        </i>
        <span *ngIf="label && label !== ''">
            {{label}}
        </span>
    </ng-container>
    <ng-container *ngIf="isFormSaveButton()">
        <span>{{'Opslaan' | translate}}</span>
    </ng-container>
</button>
